import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import { environment } from '@apps/clos-sessions/environments';
import 'focus-visible';

if (environment.production) {
  enableProdMode();
  // eslint-disable-next-line no-console
  console.log(`[APP_VERSION]: ${environment.version}`);
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
});
